import React, { useState } from "react";
import AntCheckBox from "../FormBuilderInputs/CheckBox";
import AntDatePicker from "../FormBuilderInputs/DatePicker";
import DropdownInput from "../FormBuilderInputs/DropdownInput";
import NormalInput from "../FormBuilderInputs/NormalInput";
import ContainerPreview from "../FormBuilderInputs/ContainerPreview";
import RadioGroup from "../FormBuilderInputs/RadioGroup";
import AntTextArea from "../FormBuilderInputs/TextArea";
import Toggle from "../FormBuilderInputs/Toggle";
import AntUpload from "../FormBuilderInputs/Upload";
import AntButton from "../FormBuilderInputs/Button";
import AntHeader from "../FormBuilderInputs/Header";
import Image from "../FormBuilderInputs/Image";
import Label from "../FormBuilderInputs/Label";
import Link from "../FormBuilderInputs/Link";
import ProgressCircle from "../FormBuilderInputs/ProgressCircle";
import ProgressLine from "../FormBuilderInputs/ProgressLine";
import UISignature from "../FormBuilderInputs/Signature";
import SnippetCamera from "../FormBuilderInputs/Camera";
import Popup from "../Helpers/Popup/Popup";
import PopupTitle from "../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../Helpers/CloseBtn/Close";
import { Modal } from "react-bootstrap";
import { Segmented } from "antd";
import {
	AppstoreOutlined,
	BarsOutlined,
	DesktopOutlined,
	MobileOutlined,
	TabletOutlined,
} from "@ant-design/icons";
import trans from "../../utils";

export default function FormPerview({ preview, setPreview, data, name }) {
	const getInputType = (item) => {
		switch (item?.name) {
			case "Checkbox":
				return <AntCheckBox item={item} />;
			case "DatePicker":
				return <AntDatePicker item={item} preview={true} />;
			case "Dropdown":
				return <DropdownInput item={item} preview={true} />;

			case "Input":
				return <NormalInput item={item} preview={true} />;
			case "Container":
				return (
					<ContainerPreview
						getInputType={getInputType}
						ukey={item?.id}
						item={item?.container}
						css={item?.css}
					/>
				);
			case "Radio_group":
				return <RadioGroup item={item} preview={true} />;

			case "Text_area":
				return <AntTextArea item={item} preview={true} />;

			case "Toggle":
				return <Toggle item={item} />;
			case "Uploader":
				return <AntUpload item={item} />;
			case "Button":
				return <AntButton item={item} />;

			case "Header":
				return <AntHeader item={item} />;
			case "Image":
				return <Image item={item} />;
			case "Label":
				return <Label item={item} />;
			case "Link":
				return <Link item={item} />;

			case "Progress_circle":
				return <ProgressCircle item={item} />;
			case "Progress_line":
				return <ProgressLine item={item} />;
			case "Signature":
				return <UISignature item={item} preview={true} />;
			case "Camera":
				return <SnippetCamera item={item} preview={true} />;
			default:
				return;
		}
	};
	const closeform = () => {
		setPreview(false);
	};
	const changeSize = (type) => {
		if (type === "mobile") {
			return "md";
		} else if (type === "tablet") {
			return "lg";
		} else if (type === "desktop") {
			return "xl";
		} else {
			return "lg";
		}
	};
	const [screen, setScreen] = useState("desktop");
	return (
		<div>
			<Popup show={preview} size={changeSize(screen)}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={`${name ? name : ""}`}
							subtitle={trans("This is how your form will appear to workers")}
						/>
					</Modal.Title>
					<div className="d-flex align-items-center">
						<Segmented
							options={[
								{
									value: "mobile",
									icon: <MobileOutlined title={trans("Mobile perspective")} />,
								},
								{
									value: "tablet",
									icon: <TabletOutlined title={trans("Tablet perspective")} />,
								},
								{
									value: "desktop",
									icon: (
										<DesktopOutlined title={trans("Desktop perspective")} />
									),
								},
							]}
							style={{ marginInline: "12px" }}
							value={screen}
							onChange={(value) => setScreen(value)}
						/>
						<Close
							// eslint-disable-next-line react/style-prop-object
							style="close-32 close"
							close={closeform}
							img="Close"
						/>
					</div>
				</Modal.Header>
				<Modal.Body
					className="modal-body-scrollable"
					style={{ height: "calc(100vh - 140px)", overflowX: "hidden" }}
				>
					{data?.map((i) => (
						<div className={`mb-2`} style={i.css}>
							{getInputType(i)}
						</div>
					))}
				</Modal.Body>
			</Popup>
		</div>
	);
}
